// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';

// action - mission reducer

export const MISSIONS_PENDING = 'MISSIONS_PENDING';
export const MISSIONS_FAILURE = 'MISSIONS_FAILURE';

// get missions
// export const GET_MISSIONS_PENDING = 'GET_MISSIONS_PENDING';
export const GET_MISSIONS_SUCCESS = 'GET_MISSIONS_SUCCESS';
// export const GET_MISSIONS_FAILURE = 'GET_MISSIONS_FAILURE';

// get  mission
// export const GET_MISSION_PENDING = 'GET_MISSION_PENDING';
export const GET_MISSION_SUCCESS = 'GET_MISSION_SUCCESS';
// export const GET_MISSION_FAILURE = 'GET_MISSION_FAILURE';

// get current mission
// export const GET_CURRENT_MISSION_PENDING = 'GET_CURRENT_MISSION_PENDING';
export const GET_CURRENT_MISSION_SUCCESS = 'GET_CURRENT_MISSION_SUCCESS';
// export const GET_CURRENT_MISSION_FAILURE = 'GET_CURRENT_MISSION_FAILURE';

// create mission
// export const CREATE_MISSION_PENDING = 'CREATE_MISSION_PENDING';

export const CREATE_MISSION_SUCCESS = 'CREATE_MISSION_SUCCESS';
// export const CREATE_MISSION_FAILURE = 'CREATE_MISSION_FAILURE';
// update mission
// export const UPDATE_MISSION_PENDING = 'UPDATE_MISSION_PENDING';

export const UPDATE_MISSION_SUCCESS = 'UPDATE_MISSION_SUCCESS';
// export const UPDATE_MISSION_FAILURE = 'UPDATE_MISSION_FAILURE';
// delete mission
// export const DELETE_MISSION_PENDING = 'DELETE_MISSION_PENDING';

export const DELETE_MISSION_SUCCESS = 'DELETE_MISSION_SUCCESS';
// export const DELETE_MISSION_FAILURE = 'DELETE_MISSION_FAILURE';

// assign mission
// export const MISSION_ASSIGN_PENDING = 'MISSION_ASSIGN_PENDING';
export const MISSION_ASSIGN_SUCCESS = 'MISSION_ASSIGN_SUCCESS';
// export const MISSION_ASSIGN_FAILURE = 'MISSION_ASSIGN_FAILURE';

// cancel mission
// export const MISSION_CANCEL_PENDING = 'MISSION_CANCEL_PENDING';
export const MISSION_CANCEL_SUCCESS = 'MISSION_CANCEL_SUCCESS';
// export const MISSION_CANCEL_FAILURE = 'MISSION_CANCEL_FAILURE';

// execute current mission
// export const EXECUTE_CURRENT_MISSION_PENDING = 'EXECUTE_CURRENT_MISSION_PENDING';
export const EXECUTE_CURRENT_MISSION_SUCCESS =
    'EXECUTE_CURRENT_MISSION_SUCCESS';
// export const EXECUTE_CURRENT_MISSION_FAILURE = 'EXECUTE_CURRENT_MISSION_FAILURE';

// clear drone commands
// export const CLEAR_DRONE_COMMANDS_PENDING = 'CLEAR_DRONE_COMMANDS_PENDING';
export const CLEAR_DRONE_COMMANDS_SUCCESS = 'CLEAR_DRONE_COMMANDS_SUCCESS';
// export const CLEAR_DRONE_COMMANDS_FAILURE = 'CLEAR_DRONE_COMMANDS_FAILURE';

// save mission
// export const SAVE_MISSION_PENDING = 'SAVE_MISSION_PENDING';
export const SAVE_MISSION_SUCCESS = 'SAVE_MISSION_SUCCESS';
// export const SAVE_MISSION_FAILURE = 'SAVE_MISSION_FAILURE';
